function limiter(concurrency) {
    let activeCount = 0;
    const queue = [];

    const next = () => {
        if (activeCount >= concurrency || queue.length === 0) return;

        activeCount++;
        const { task, resolve, reject } = queue.shift();

        task()
            .then(resolve)
            .catch(reject)
            .finally(() => {
                activeCount--;
                next();
            });
    };

    return function (task) {
        return new Promise((resolve, reject) => {
            queue.push({ task, resolve, reject });
            next();
        });
    };
}

export {
    limiter,
}
